const screenSizes = {
    xs: {
        min: 0,
        max: 319,
    },
    sm: {
        min: 320,
        max: 639,
    },
    md: {
        min: 640,
        max: 767,
    },
    lg: {
        min: 768,
        max: 1023,
    },
    xl: {
        min: 1024,
        max: 9999,
    },
};
const { sm, md, lg, xl } = screenSizes;
const breakpointPxs = [
    `${sm.min}px`,
    `${md.min}px`,
    `${lg.min}px`,
    `${xl.min}px`,
];
export { screenSizes, breakpointPxs };
//# sourceMappingURL=screenSizes.js.map